import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table'
import 'tippy.js/dist/tippy.css';
import ContentLoader from "react-content-loader";
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import _ from "lodash";

import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import DeleteNotificationService from "../../../../services/party/notification/deleteNotificationService";
import { getTrans as t } from "../../../../Localization/translations";
import EditNotification from "./EditNotification";
import AddNotification from "./AddNotification";


function ManageNotification({ id,
	setHideShowNotify,
	setHideShowNotifyEdit,
	hideShowNotify,
	hideShowNotifyEdit,
	setNotifyId
 }) {
const NotificationtableRef = React.createRef();

const [loading, setLoading] = useState(true)
const [hideshowedit, setHideShowEdit] = useState(false)
const [notificationid, setNotifiactionID] = useState("");

const handleEdit = (notification_id) => {
	setNotifiactionID(notification_id)
	setNotifyId(notification_id)
	// setHideShowEdit(true)
	setHideShowNotify(false)
	setHideShowNotifyEdit(true)
}

useEffect(() => {
	setLoading(false)
}, []);

const handelDelete = (id) => {
	confirmAlert({
		title: '',
		message: 'Are you sure you want to delete this Notification?.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					DeleteNotificationService.deletenotification(id).then(
						(response) => {
							if (response.data.success) {
								toast.success(`${response.data.response}`,{
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",})
								NotificationtableRef.current.onQueryChange()
							} else {
								toast.error(`${response.data.error}`,{
									position: "top-right",
									autoClose: 1000,
									hideProgressBar: false,
									closeOnClick: true,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "light",})
							}
						},
					)
				}
			},
			{
				label: 'No',
				// onClick: () => alert('Click No')
			}
		]
	});
}

const [hideshow, setHideShow] = useState(false)
const hideshowstate = () => {
	// setHideShow(true)
	setHideShowNotify(true)
	setHideShowNotifyEdit(false)

}

useEffect(() => {
	if (!hideShowNotify  && !hideShowNotifyEdit && NotificationtableRef.current) {
		NotificationtableRef.current.onQueryChange();
	}
  }, [hideShowNotify, hideShowNotifyEdit]);
return (
	<>
		{
		hideshow === false ?
		hideshowedit === false ?
		<>
		<div className="row ">
			{
				loading === false ? (
				<>
					<ToastContainer />
					<div className="col-md-12">
						<div className=" mb-0">
							<div className="header pb-0">
								<div className="d-lg-flex mb-2">
									<div>
										<h5 className="mb-3">{t('Manage Notification')}
										</h5>
									</div>
									<div className="ms-auto my-auto mt-lg-0 mt-4">
										<div className="ms-auto my-auto">
												<button className="btn btn-primary mb-0" id="add-task" onClick={hideshowstate}>+&nbsp; {t('New Notification')}</button>
										</div>
									</div>
								</div>
							</div>
							<div className="body">
								<div className="p-0">
									<MaterialTable
									tableRef={NotificationtableRef}
										style={{
											backgroundColor: "var(--bs-table-bg)",
											borderBottomWidth: "1px",
											boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
										}}
										columns={[
											{
												title: `${t("Notification Type")}`,
												field: "notification_type",
												render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Notification Type")}</div><div>{(rowData.notification_type)}</div></>,
												headerStyle: {
													verticalAlign: "inherit",
													fontWeight: "bold",
													textAlign: "left"
												},
												cellStyle: {
													textAlign: "left",
													fontSize: 12
												}
											},
											{
												title: `${("Notification Reminder")}`,
												field: "notification_reminder",
												render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Notification Reminder")}</div><div>{(rowData.notification_reminder)}</div></>,
												headerStyle: {
													verticalAlign: "inherit",
													fontWeight: "bold",
													textAlign: "left"
												},
												cellStyle: {
													textAlign: "left",
													fontSize: 12
												}
											},
											{
												title: `${t("Email")}`,
												field: "to_email",
												render: rowData => <> <div className="d-xl-none tc d-md-none d-lg-none">{t("Email")}</div><div>{(rowData.to_email)}</div></>,
												export: false,
												headerStyle: {
													verticalAlign: "inherit",
													fontWeight: "bold",
													textAlign: "left"
												},
												cellStyle: {
													textAlign: "left",
													fontSize: 12
												}
											},
										]}
										data={query =>
											new Promise((resolve, reject) => {
												const { orderBy, orderDirection } = query;

											  let url = API + "parties/manage-notification/" + id + "/?"
											  url += 'per_page=' + query.pageSize
											  url += '&page=' + (query.page + 1)
											  url += '&search=' + query.search
											  if (orderBy) {
												url += `&orderBy=${orderBy.field}`;
												url += `&orderDirection=${orderDirection}`;
												}
											  fetch(url, { headers: authHeader() })
												.then(response => response.json())
												.then(result => {
												  resolve({
													data: query.orderBy && query.orderDirection
													? _.orderBy(
														result.data,
														[query.orderBy.field],
														[query.orderDirection]
													  )
													: result.data,
													page: result.page - 1,
													totalCount: result.total,
												  })
												})
											})
										  }
										actions={[
											{
												icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit"/>,
												tooltip: "Edit",
												onClick: (event, rowData) => {
													handleEdit(rowData.id)
												}
											},
											{
												icon: () => <img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Delete" />,
												tooltip: "Delete",
												onClick: (event, rowData) => { handelDelete(rowData.id) }
											}
										]}
										options={{
											headerStyle: {
												backgroundColor: "white",
									color: "#245C7F",
												 fontSize: 12,
											},
											rowStyle: (rowData, index) => {
												if (index % 2) {
													return { backgroundColor: "#fff" }
												}
											},
											sorting: true,
											search: false,
											toolbar: false,
											paging: true,
											pageSize: 10,       // make initial page size
											emptyRowsWhenPaging: false,   // To avoid of having empty rows
											pageSizeOptions: [10, 15, 20, 50],
											paginationType: "stepped",
											showFirstLastPageButtons: false,
											actionsColumnIndex: -1,
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</>
				) : (
					<ContentLoader
						viewBox="0 0 1000 550"
						backgroundColor="rgba(0,0,0,0.06)"
						foregroundColor="rgba(0,0,0,0.12)"
					>
						<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
						<circle cx="879" cy="123" r="11" />
						<circle cx="914" cy="123" r="11" />
						<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
						<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
						<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
						<circle cx="880" cy="184" r="11" />
						<circle cx="915" cy="184" r="11" />
						<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
						<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
						<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
						<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
						<circle cx="881" cy="242" r="11" />
						<circle cx="916" cy="242" r="11" />
						<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
						<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
						<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
						<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
						<circle cx="882" cy="303" r="11" />
						<circle cx="917" cy="303" r="11" />
						<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
						<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
						<circle cx="881" cy="363" r="11" />
						<circle cx="916" cy="363" r="11" />
						<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
						<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
						<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
						<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
						<circle cx="882" cy="424" r="11" />
						<circle cx="917" cy="424" r="11" />
						<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
						<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
						<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
						<circle cx="882" cy="484" r="11" />
						<circle cx="917" cy="484" r="11" />
						<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
						<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
						<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
						<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
						<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
						<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
						<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
						<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
						<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
						<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
					</ContentLoader>
				)
			}
		</div>
		<div className="modal right fade" id="edit_address" tabIndex="-1" role="dialog" aria-modal="true">
		</div>

		<div className="modal right fade" id="add_address" tabIndex="-1" role="dialog" aria-modal="true">
		</div>
		</>
		:
		<EditNotification id={id} notification={notificationid}/>
		:
		<AddNotification id={id}/>
		}
	</>
)
}

export default ManageNotification
